import React, { memo } from 'react';

const SkeletonXaxis = memo( ( { className } ) => {
  return <div className={ `skeleton skeleton__x-axis ${ className }` } />
});

export default SkeletonXaxis;